import type { FaireProductEntity } from "../../entity_types/product";

export const p_live_pistakio_crunchy_pistachio_spread: FaireProductEntity = {
  token: "p_live_pistakio_crunchy_pistachio_spread",
  type: "product",
  name: "Crunchy Pistachio Spread",
  brandToken: "b_live_pistakio",
  brandName: "Pistakio",
  imageUrl:
    "https://cdn.faire.com/fastly/0b7bee3c03fb37086d2269e570214d8e07bfe400a885dd40d3ec06674d01c0f3.webp?bg-color=FFFFFF&fit=crop&format=jpg&height=400&width=400",
  priceDollars: 11.18,
  msrpDollars: 15,
  description: "Crunchy pistachio spread used in Live Shopping mocks.",
  categoryTokens: ["cat_food-drink"],
  tags: ["live-shopping", "bestseller", "spreads"],
  isBestseller: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "live-shopping-migration",
  },
};
